import React from 'react';
import { Col, Row } from '../../../lib/utils';
import { Body3Bold, CaptionRegular, Body3Regular } from '../../../lib/font';
import { colors } from '../../../lib/colors';
import { mustMoveCompanyLegalInfo } from '../../../lib/mustMoveCompanyLegalInfo';
import { PaymentRequest } from '../data/dummyData';

interface SellerInfoSectionProps {
    data: PaymentRequest;
}

const InfoRow: React.FC<{ label: string; value: string }> = ({ label, value }) => (
    <Row style={{ alignItems: 'flex-start', padding: '6px 0' }}>
        <CaptionRegular style={{ color: colors.LAVEL_2, minWidth: 104 }}>{label}</CaptionRegular>
        <Body3Regular style={{ color: colors.LAVEL_3, flex: 1 }}>{value}</Body3Regular>
    </Row>
);

const SellerInfoSection: React.FC<SellerInfoSectionProps> = ({ data }) => {
    return (
        <Col
            style={{
                width: '100%',
                backgroundColor: '#FFFFFF',
                borderRadius: 16,
                padding: '24px 20px',
                boxShadow: '0 2px 12px rgba(0, 0, 0, 0.06)',
            }}
        >
            <Body3Bold style={{ color: colors.LAVEL_4, marginBottom: 12 }}>판매자 정보</Body3Bold>
            <InfoRow label="이용 센터" value={data.centerName} />
            <InfoRow label="상호명" value={mustMoveCompanyLegalInfo.officialTradeName} />
            <InfoRow label="대표자명" value={mustMoveCompanyLegalInfo.representativeName} />
            <InfoRow label="사업자등록번호" value={mustMoveCompanyLegalInfo.businessRegistrationNumber} />
            <InfoRow label="사업장 주소" value={mustMoveCompanyLegalInfo.address} />
            <InfoRow label="상점 전화번호" value={mustMoveCompanyLegalInfo.phone} />
            <InfoRow label="통신판매업 신고번호" value={`제 ${mustMoveCompanyLegalInfo.mailOrderSalesReportNumber}`} />
            <InfoRow label="고객문의" value={mustMoveCompanyLegalInfo.customerInquiry} />
        </Col>
    );
};

export default SellerInfoSection;
